import { useContext, useMemo } from 'react'
import {
  buildPanelCheckItems,
} from 'components/Cruises/SearchPage/Filters/Inputs/CruiseExtraFiltersInputs'
import FilterPanelCheckboxGroup from 'components/Common/FilterPanel/FilterPanelCheckboxGroup'
import config from 'constants/config'
import { LUXURY_ESCAPES } from 'constants/brands'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'

import * as Analytics from 'analytics/analytics'
import { mapCruiseLineFilterToSnowplowSearchEvent } from 'analytics/mapSnowplowSearchTracking'
import { searchEventWithContext } from 'analytics/snowplow/events'

const isLuxuryEscapes = config.BRAND === LUXURY_ESCAPES

interface Props {
  isLuxExclusivePromotion?: Set<string>
  isSpecialOffers?: Set<string>
  onChange: (nextFilters: Record<string, any>) => void
  facets: Array<App.CruiseSearchFacet>
}

function CruisePromotionFilter({
  isLuxExclusivePromotion,
  isSpecialOffers,
  onChange,
  facets,
}: Props) {
  const globalSearchState = useContext(GlobalSearchStateContext)

  const { leExclusiveItems, hasLuxExclusiveItems } = useMemo(() => {
    const luxExclusiveFacets = facets.filter(facet => facet.category === 'lux_exclusive')

    return {
      leExclusiveItems: buildPanelCheckItems(luxExclusiveFacets),
      hasLuxExclusiveItems: luxExclusiveFacets.some(facet => !!facet.count),
    }
  }, [facets])
  const { specialOffersItems, hasSpecialOffersItems } = useMemo(() => {
    const specialOffersFacets = facets.filter(facet => facet.category === 'special_offers')
    return {
      specialOffersItems: buildPanelCheckItems(specialOffersFacets),
      hasSpecialOffersItems: specialOffersFacets.some(facet => !!facet.count),
    }
  }, [facets])

  return <div data-testid="cruise-promotion-filter">
    {isLuxuryEscapes && hasLuxExclusiveItems && <FilterPanelCheckboxGroup
      name="isLuxExclusivePromotion"
      items={leExclusiveItems}
      onChange={(e) => {
        Analytics.trackEvent(searchEventWithContext({
          searchEvent: { type: 'filters' },
          sortContext: { value: 'recommended' },
          searchContext: mapCruiseLineFilterToSnowplowSearchEvent(globalSearchState),
          filterContexts: [{
            label: 'Lux Plus Exclusive',
            type: 'lux_plus_exclusive',
            value: e.target.checked ? 'selected' : 'unselected',
          }],
        }))
        onChange(e)
      }}
      defaultSelected={isLuxExclusivePromotion}
    />}

    {hasSpecialOffersItems && <FilterPanelCheckboxGroup
      name="isSpecialOffers"
      items={specialOffersItems}
      onChange={(e) => {
        Analytics.trackEvent(searchEventWithContext({
          searchEvent: { type: 'filters' },
          sortContext: { value: 'recommended' },
          searchContext: mapCruiseLineFilterToSnowplowSearchEvent(globalSearchState),
          filterContexts: [{
            label: 'Special Offers',
            type: 'special_offers',
            value: e.target.checked ? 'selected' : 'unselected',
          }],
        }))
        onChange(e)
      }}
      defaultSelected={isSpecialOffers}
    />}
  </div>
}

export default CruisePromotionFilter
